$(document).ready(function () {
    $(".div_branch_offices").show()
    initCampaignOrdenToggle()
    initCampaignTipoToggle()
    toggleOrdenField($("#item-tipo").val())
    toggleTipoFields($("#item-tipo").val())
    toggleConvenioColumns($("#item-tipo").val())

    function initCampaignTipoToggle() {
        const $tipo = $("#item-tipo")

        $tipo.off("change.campaignTipo chosen:updated.campaignTipo")
        $tipo.on("change.campaignTipo chosen:updated.campaignTipo", function () {
            toggleTipoFields($(this).val())
            toggleOrdenField($(this).val())
            toggleConvenioColumns($(this).val())
        })
    }

    function toggleTipoFields(tipo) {
        if (tipo === "PORCENTAJES") {
            $(".div-campaign-porcentaje").hide()
            $("#item-porcentaje").val(0).prop("required", false)
        } else {
            $(".div-campaign-porcentaje").show()
            $("#item-porcentaje").prop("required", true)
        }
    }

    function initCampaignOrdenToggle() {
        const $tipo = $("#item-tipo")

        $tipo.off("change.campaignOrden chosen:updated.campaignOrden")
        $tipo.on("change.campaignOrden chosen:updated.campaignOrden", function () {
            toggleOrdenField($(this).val())
        })
    }

    function toggleOrdenField(tipo) {
        if (tipo === "CONVENIO") {
            $(".div-campaign-orden").show()
            $("#item-orden").prop("disabled", false)
        } else {
            $(".div-campaign-orden").hide()
            $("#item-orden").val(0).prop("disabled", true)
        }
    }

    function toggleConvenioColumns(tipo) {
        const $cols = $(".div-campaign-tipo, .div-campaign-orden, .div-campaign-porcentaje")

        if (tipo === "CONVENIO") {
            $cols.removeClass("col-md-3").addClass("col-md-2")
        } else {
            $cols.removeClass("col-md-2").addClass("col-md-3")
        }
    }

    $('#modal-campaign').on('shown.bs.modal', function () {
        initCampaignOrdenToggle()
        initCampaignTipoToggle()
        toggleOrdenField($('#item-tipo').val())
        toggleTipoFields($('#item-tipo').val())
        toggleConvenioColumns($('#item-tipo').val())
    })

    $("#table-campigns").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
        responsive: true,
        ajax: 'get-campaigns',
        order: [0],
        columns: [
            {data: 'id', name: 'id'},
            {data: 'descripcion', name: 'descripcion'},
            {data: 'porcentaje', name: 'porcentaje'},
            {data: 'tipo', name: 'tipo'},
            {data: 'id', name: 'id'},//Sucursal_id
            {data: 'fecha', name: 'fecha'},
        ],
        "columnDefs": [{
            "targets": 6,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                console.log(row)
                let status = get_global_status(row.status)
                let porcentajesBtn = ''

                const articlesBtn = '<button data-toggle="tooltip" data-placement="top" title="Agregar articulos" class="btn laproveedora_btn ' +
                    'add-articles-to-campaign m-1 btn-sm" data-uuid="' + row.uuid + '" data-description="' + row.descripcion + '">' +
                    '<i class="fa-solid fa-book"></i></button> '

                if (row.tipo === 'PORCENTAJES') {
                    porcentajesBtn = '<button data-toggle="tooltip" data-placement="top" title="Agregar registro" class="btn laproveedora_btn ' +
                        'add-porcentajes-to-campaign m-1 btn-sm" data-uuid="' + row.uuid + '" data-description="' + row.descripcion + '">' +
                        '<i class="fa-solid fa-percent"></i></button> '
                }

                return '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn laproveedora_btn ' +
                    'edit-campaign m-1 btn-sm"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></button> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="Editar sucursales" class="btn laproveedora_btn ' +
                    'edit-branchOffice m-1 btn-sm"' +
                    'data-uuid ="' + row.uuid + '"><i class="fa-regular fa-building"></i></button> ' +

                    articlesBtn +
                    porcentajesBtn +

                    '<a href="#" data-toggle="tooltip" data-placement="top" title="' + status.title +   '" ' +
                    'class="btn m-1 btn-' + status.color_clas + ' change-campaing-status btn-sm"  ' +
                    'data-campaign ="' + row.uuid + '"><span class="' + status.icon + '"></span></a> '
            }
        }]
    });

    $("#new-campaign").on('click', function (e) {
        e.preventDefault()
        $("#item-dir").val('new');
        $("#item-id").val('')
        $(".div_branch_offices").show()
        $(".modal-title").html('Crear campaña')
        clearInputs()
        $("#modal-campaign").modal('show')
    })

    $("#table-campigns tbody").on('click', '.change-campaing-status', function () {
        let uuid = $(this).data('campaign');
        let data = new FormData()
        data.append('uuid', uuid)
        sendData(data, '/actualizar-status-campania')
    });

    $("#table-campigns tbody").on('click', '.edit-campaign', function () {
        let list_campaign = $("#table-campigns").DataTable();
        let rowData = list_campaign.row($(this).parents('tr')).data();
        $("#item-dir").val('edit');
        $(".modal-title").html('Editar campaña')
        $(".div_branch_offices").hide()
        $.each(rowData, function (index, value) {
            $("#item-" + index).val(value)
            if (index == "tipo" || index == "group") {
                $("#item-" + index).val(value).trigger("chosen:updated");
            }
        })
        $("#modal-campaign").modal('show')
    })


    $("#form-campaign").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        if ($("#item-tipo").val() !== 'CONVENIO') {
            data.set('orden', '0')
        }
        if ($("#item-tipo").val() === 'PORCENTAJES') {
            data.set('porcentaje', '0')
        }
        let dir = $("#item-dir").val()
        let route = getRoute(dir)
        sendData(data, route);
    })

    function sendData(data, route) {
        togglePreloader();
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                console.log(response)
                togglePreloader();
                if (response.type == "errorConnection") {
                    alertError(response.msg)
                } else if (response.type == "error") {
                    alertError(response.msg)
                } else if (response.type == "success-update-status") {
                    $("#table-campigns").DataTable().ajax.reload();
                    alertSuccess(response.msg)
                }
                if (response.type == "success") {
                    alertSuccess(response.msg)
                    if (response.msgError) {
                        alertError(response.msgError)
                    }
                    $("#table-campigns").DataTable().ajax.reload();
                    $("#modal-campaign").modal('hide')
                }
            }, error: function (errors, xhr, status,) {
                togglePreloader();
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $("#error-" + index).text(value);
                });
            }
        })
    }

    function getRoute(route) {
        if (route == "new") {
            return '/crear-campania'
        }
        return '/editar-campania'
    }

    function clearInputs() {
        $(".item-descripcion").val('')
        $(".item-porcentaje").val('').prop('required', true)
        $(".div-campaign-porcentaje").show()
        $(".div-campaign-tipo, .div-campaign-orden, .div-campaign-porcentaje").removeClass("col-md-2").addClass("col-md-3")
        $(".item-orden").val(0).prop('disabled', true)
        $(".div-campaign-orden").hide()
        $(".item-fecha_inicio").val('')
        $(".item-fecha_fin").val('')
        $(".item-tipo").val('').trigger('chosen:updated')
        $(".item-sucursal_id").chosen().val('').trigger('chosen:updated')
        $(".item-group").chosen().val('').trigger('chosen:updated')
    }

    window.validar = function ( input ) {
        if (input.value < 0 ) {
            input.value = ''
        }
    }


});
